export enum SectionName {
	// Logged-out hero section.
	Hero = 'hero',
	// Logged-out overview section.
	Overview = 'overview',
	// Logged-out 3-panel scroll carousel rendered inside the overview section.
	OverviewCarousel = 'overviewCarousel',
	// Logged-out graph preview panel rendered inside the overview section.
	GraphPreviewPanel = 'graphPreviewPanel',
	// Logged-out "Results that speak for themselves" supplemental section.
	Results = 'results',
	// Logged-out "See your Teamwork Graph in action" supplemental section.
	GraphInAction = 'graphInAction',
	// Shared between logged-out and logged-in experiences.
	ConnectorShowcase = 'connectorShowcase',
	GettingStarted = 'gettingStarted',
	Footer = 'footer',
	// Logged-in sections.
	Introduction = 'introduction',
	GraphPreview = 'graphPreview',
	ConnectedApps = 'connectedApps',
	Collaborators = 'collaborators',
	UserGraph = 'userGraph',
}

/** Auth state captured on every per-section analytics event. */
export type AuthState = 'loggedIn' | 'loggedOut';
